// export const APIURL ="https://carrefourapi.mayanksoftwares.co/v1/";
// export const APIURL ="https://vendorportalapi.hypermaxcity.in/v1/";
export const getApiUrl = () => {
  const hostname = window.location.hostname;

  // PROD
  if (hostname === "vendorportal.hypermaxcity.in") {
    return "https://vendorportalapi.hypermaxcity.in/v1/";
  }

  // QA / UAT
  if (hostname === "vendorportaluat.hypermaxcity.in") {
    return "https://vendorportalapiuat.hypermaxcity.in/v1/";
  }

  // DEV
  if (hostname === "carrefour.mayanksoftwares.co") {
    return "https://carrefourapi.mayanksoftwares.co/v1/";
  }

  // LOCAL fallback (optional but recommended)
  // return "https://carrefourapi.mayanksoftwares.co/v1/";
  return "https://vendorportalapiuat.hypermaxcity.in/v1/";
};

export const APIURL = getApiUrl();

export const TEMPLATEBASEURL =
  "https://hypermaxblockblobstorage.blob.core.windows.net/vendorportalapplication/";
